import { Link, useLocation, useNavigate } from "react-router-dom";
import { useQueryClient } from "@tanstack/react-query";

const menuList = [
  {
    label: "สินค้าทั้งหมด",
    link: "/",
  },
  {
    label: "แลกคะแนน",
    link: "/capsule-market",
  },
  {
    label: "เงื่อนไขการเปลี่ยนคืนสินค้า",
    link: "/return-policy",
  },
  {
    label: "รายการสั่งซื้อ",
    link: "/setting/order-history",
  },
];
const Header = () => {
  const { pathname } = useLocation();
  const navigate = useNavigate();
  const queryClient = useQueryClient();

  const handleLogoClick = () => {
    if (pathname === "/") {
      // If already on home page, refetch product data
      queryClient.invalidateQueries({
        queryKey: ["getProduct"],
      });
    } else {
      // If on other pages, navigate to home
      navigate("/");
    }
  };

  return (
    <header className="h-[85px] bg-white flex justify-between px-2">
      <div className="cursor-pointer" onClick={handleLogoClick}>
        <div className="flex">
          <img
            className="my-auto mr-4"
            src="/logo.png"
            width={69}
            height={69}
          />
          <div className="flex flex-col justify-center">
            <div>
              <span className="font-semibold mr-2">นรินทร์เภสัช</span>
              <small>ชัยภูมิ</small>
            </div>
            <div>NARINONLINE</div>
          </div>
        </div>
      </div>
      <div className="flex items-center gap-4">
        {menuList.map((menu) => {
          return (
            <Link to={menu.link} key={menu.link}>
              <div
                className={
                  pathname === menu.link ? "menu-active" : "text-black"
                }
                key={menu.link}
              >
                {menu.label}
              </div>
            </Link>
          );
        })}
      </div>
    </header>
  );
};

export default Header;
